import React from "react";
import { MEDIA_BASE_URL } from "../../api";
import "./productPages.css";

/**
 * Shared product showcase card used by the portfolio product pages.
 * - title:  card heading
 * - subtitle: optional smaller line under the heading
 * - images: array of image paths (1 or 2 shown side by side)
 * - specs:  [{ label, value }] — entries with empty values are skipped
 * - badges: array of strings rendered as accent pills
 * - points: array of strings rendered as an accent checklist
 * - action: optional { label, onClick } button
 */
export default function ProductShowcase({ title, subtitle, images = [], specs = [], badges = [], points = [], action }) {
  const shownSpecs = specs.filter((s) => s.value !== undefined && s.value !== null && s.value !== "");
  const shownImages = images.filter(Boolean).slice(0, 2);

  return (
    <article className="pp-card product-surface-card">
      <div className={`pp-media${shownImages.length > 1 ? " pp-media-multi" : ""}`}>
        {shownImages.map((path, i) => (
          <img key={i} src={`${MEDIA_BASE_URL}${path}`} alt={title} loading="lazy" />
        ))}
      </div>

      <div className="pp-body">
        <h3 className="pp-name">{title}</h3>
        {subtitle && <p className="pp-subtitle">{subtitle}</p>}

        {shownSpecs.length > 0 && (
          <dl className="pp-specs">
            {shownSpecs.map((s) => (
              <div className="pp-spec" key={s.label}>
                <dt>{s.label}</dt>
                <dd>{s.value}</dd>
              </div>
            ))}
          </dl>
        )}

        {points.filter(Boolean).length > 0 && (
          <div className="pp-points">
            {points.filter(Boolean).map((pt) => (
              <div className="pp-feature" key={pt}>{pt}</div>
            ))}
          </div>
        )}

        {badges.filter(Boolean).length > 0 && (
          <div className="pp-badges">
            {badges.filter(Boolean).map((b) => (
              <span className="pp-badge" key={b}>{b}</span>
            ))}
          </div>
        )}

        {action && (
          <div className="pp-action">
            <button type="button" className="pp-link-btn" onClick={action.onClick}>
              {action.label} →
            </button>
          </div>
        )}
      </div>
    </article>
  );
}

/** Compact clickable case-study card used by launcher pages (mushroom farms, WHR, …). */
export function SiteCard({ image, title, caption, onOpen }) {
  return (
    <button type="button" className="pp-site-card product-surface-card" onClick={onOpen}>
      <img src={`${MEDIA_BASE_URL}${image}`} alt={title} loading="lazy" />
      <span className="pp-site-body">
        <span className="pp-site-name">{title}</span>
        {caption && <span className="pp-site-caption">{caption}</span>}
        <span className="pp-site-link">View case study →</span>
      </span>
    </button>
  );
}
